import React, { useState, useEffect } from 'react';
import styled, { createGlobalStyle, css } from 'styled-components';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import Tour from 'reactour';
import { sendCustomTrackingInfo } from '@panel/commons';
import { select } from '@panel/commons/core/themev2';
import { useTranslation } from 'react-i18next';
import useHideBotMarker from '@panel/commons/hooks/useHideBotmarker';
import Step from './Step';

const TourContainer = ({ setShowTour, showTour }) => {
  const { t } = useTranslation();
  const [currentStepId, setCurrentStepId] = useState(1);
  const [clickedEndCTA, setClickedEndCTA] = useState('');
  useHideBotMarker(showTour);

  useEffect(() => {
    setClickedEndCTA(false);
  }, [clickedEndCTA]);

  const boxStyle = {
    minHeight: '152px',
    width: '328px',
    padding: '16px'
  };

  const tourConfig = [
    {
      style: boxStyle,
      selector: '[data-tour-panel="estadisticas-metrics"]',
      content: (
        <Step
          id={1}
          onClose={() => {
            setShowTour(false);
          }}
          title={t('panel.estadisticas.tourVA.step1.title')}
          bodyText={t('panel.estadisticas.tourVA.step1.body')}
        />
      ),
      position: 'bottom'
    },
    {
      style: boxStyle,
      selector: '[data-tour-panel="estadisticas-conversionChart"]',
      highlightedSelectors: ['[data-tour-panel="estadisticas-contactsChart"]'],
      content: (
        <Step
          id={2}
          onClose={() => setShowTour(false)}
          title={t('panel.estadisticas.tourVA.step2.title')}
          bodyText={t('panel.estadisticas.tourVA.step2.body')}
        />
      ),
      position: 'top'
    }
  ];

  const disableBody = target => disableBodyScroll(target);
  const enableBody = target => enableBodyScroll(target);

  return (
    <>
      <OverrideCss />
      <Tour
        data-panel='panel-tour-container'
        onAfterOpen={disableBody}
        onRequestClose={() => setShowTour(false)}
        onBeforeClose={e => {
          enableBody(e);
          if (!clickedEndCTA) {
            sendCustomTrackingInfo({
              event: 'click_modal',
              modal_name: `Tour virtual - ${currentStepId === 1 ? 'Metricas' : 'Conversion'}`,
              selection_value: 'Cerrar'
            });
          }
          setCurrentStepId(1);
          window.scroll({
            top: 0,
            behavior: 'smooth'
          });
        }}
        showCloseButton={false}
        steps={tourConfig}
        isOpen={showTour}
        rounded={8}
        startAt={0}
        getCurrentStep={curr => setCurrentStepId(curr + 1)}
        disableDotsNavigation
        disableInteraction
        closeWithMask={false}
        showNumber={false}
        nextButton={React.createElement(
          'div',
          {},
          <NavButton
            data-panel='panel-tour-nvaButton-next'
            isNext
            as='div'
            onClick={() => {
              sendCustomTrackingInfo({
                event: 'click_modal',
                modal_name: 'Tour virtual - Metricas',
                selection_value: 'Siguiente'
              });
            }}
          >
            {t('panel.estadisticas.tourVA.next')}
          </NavButton>
        )}
        prevButton={React.createElement(
          'div',
          {},
          <NavButton
            data-panel='panel-tour-nvaButton-back'
            as='div'
            onClick={() => {
              sendCustomTrackingInfo({
                event: 'click_modal',
                modal_name: 'Tour virtual - Conversion',
                selection_value: 'Anterior'
              });
            }}
          >
            {t('panel.estadisticas.tourVA.prev')}
          </NavButton>
        )}
        lastStepNextButton={React.createElement(
          'div',
          {},
          <NavButton
            data-panel='panel-tour-nvaButton-finish'
            isNext
            as='div'
            onClick={() => {
              sendCustomTrackingInfo({
                event: 'click_modal',
                modal_name: 'Tour virtual - Conversion',
                selection_value: 'Finalizar'
              });
              if (currentStepId === 2) setClickedEndCTA(true);
            }}
          >
            {t('panel.estadisticas.tourVA.finish')}
          </NavButton>
        )}
        maskClassName='custom-tour-mask'
        maskSpace={11}
      />
    </>
  );
};

const OverrideCss = createGlobalStyle`
[data-tour-elem="controls"]{
  justify-content:space-between;
}
[data-tour-elem="left-arrow"]{
  :disabled{
    opacity:0;
  }
}
button.reactour__dot{
  color: #CBD6DC!important;
  background: #CBD6DC!important;
}
button.reactour__dot--is-active{
  color: #7C98A7!important;
  background: #7C98A7!important;
}
.reactour__helper{
  max-width: 328px;
}
.custom-tour-mask{
  opacity:0.6;
}
`;

const NavButton = styled.button`
  width: 80px;
  height: 40px;
  background-color: ${select('white')};
  border-radius: 12px;
  font-family: Hind;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 18px;
  letter-spacing: 0em;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  :disabled {
    opacity: 0;
  }
  ${({ isNext }) =>
    isNext &&
    css`
      background-color: ${select('orange')};
      color: white;
    `}
`;

export default TourContainer;
